import { Box } from '@mui/material'
import { PropsWithChildren } from 'react'

export interface ITabPanelProps {
  children?: React.ReactNode;
  index: number | string;
  value: number | string;
}

export const CustomTabPanel: React.FC<PropsWithChildren<ITabPanelProps>> = ({
  children,
  index,
  value,
  ...other }) => {

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}